import { apiFetchInit, apiUrl } from "@/lib/apiOrigin";

export async function apiGet<T>(
  path: string,
): Promise<{ ok: boolean; status: number; data: T | null; error?: string }> {
  try {
    const res = await fetch(apiUrl(path), { cache: "no-store", ...apiFetchInit() });
    const data = (await res.json().catch(() => null)) as T | null;
    if (!res.ok) {
      const err =
        data && typeof data === "object" && "error" in data
          ? String((data as { error?: string }).error)
          : res.statusText;
      return { ok: false, status: res.status, data: null, error: err };
    }
    return { ok: true, status: res.status, data };
  } catch (e) {
    return {
      ok: false,
      status: 0,
      data: null,
      error: e instanceof Error ? e.message : "Network error",
    };
  }
}

export async function apiPost<T>(
  path: string,
  body: unknown,
): Promise<{ ok: boolean; status: number; data: T | null; error?: string }> {
  try {
    const res = await fetch(apiUrl(path), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      cache: "no-store",
      ...apiFetchInit(),
    });
    const data = (await res.json().catch(() => null)) as T | null;
    if (!res.ok) {
      const err =
        data && typeof data === "object" && "error" in data
          ? String((data as { error?: string }).error)
          : res.statusText;
      return { ok: false, status: res.status, data, error: err };
    }
    return { ok: true, status: res.status, data };
  } catch (e) {
    return {
      ok: false,
      status: 0,
      data: null,
      error: e instanceof Error ? e.message : "Network error",
    };
  }
}
